import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { IManuallySetPrice } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  id: string;
  goodItemsIds: string[];
  newPrice: number;
}
export const useManuallySetPrice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, goodItemsIds, newPrice }: HookProps) => {
      const {
        data: { declaration },
      }: { data: IManuallySetPrice } = await request({
        path: `declarations/${id}/manuallySetPrice`,
        method: 'POST',
        authenticate: true,
        dataObject: { goodItemsIds, price: newPrice },
      });

      return declaration;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Price was set successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error setting the price!`);
    },
  });
};
